import React, { type FC, memo, useEffect, useState } from 'react';

import styles from './AiPhotoGenerationLoaderText.css';

interface IProps {
    text?: string;
}

export const AiPhotoGenerationLoaderText: FC<IProps> = memo(function AiPhotoGenerationLoaderText(props) {
    const { text } = props;

    const [displayText, setDisplayText] = useState(text);
    const [isHiding, setIsHiding] = useState(false);

    useEffect(() => {
        if (text === displayText) {
            if (isHiding) {
                setIsHiding(false);
            }
            return;
        }

        setIsHiding(true);
        const timer = setTimeout(() => {
            setDisplayText(text);
            setIsHiding(false);
        }, 150);

        return () => clearTimeout(timer);
    }, [text, displayText, isHiding]);

    return <span className={isHiding ? `${styles.text} ${styles.textHiding}` : styles.text}>{displayText}</span>;
});

AiPhotoGenerationLoaderText.displayName = 'AiPhotoGenerationLoaderText';
